<div class="dialog-header">
  <h2 mat-dialog-title>Указать ВРМСХ</h2>
  <button mat-icon-button (click)="close()" class="close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <div class="app-info">
    <p><strong>Заявка №:</strong> {{ data.application.applicationNumber }}</p>
    <p><strong>Компания:</strong> {{ data.application.companyName }}</p>
  </div>

  <form class="form-content">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>ПИН</mat-label>
      <input matInput [(ngModel)]="personIdnp" name="personIdnp"
             inputmode="numeric" pattern="[0-9]*" maxlength="14"
             (input)="onNumericInput($event, 'personIdnp')">
    </mat-form-field>
    @if (getFieldError('personIdnp')) {
      <div class="field-error">{{ getFieldError('personIdnp') }}</div>
    }

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>ИНН организации</mat-label>
      <input matInput [(ngModel)]="organizationInn" name="organizationInn"
             inputmode="numeric" pattern="[0-9]*" maxlength="14"
             (input)="onNumericInput($event, 'organizationInn')">
    </mat-form-field>
    @if (getFieldError('organizationInn')) {
      <div class="field-error">{{ getFieldError('organizationInn') }}</div>
    }

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Статус ВРМСХ</mat-label>
      <mat-select [(ngModel)]="veterinaryDocumentStatus" name="veterinaryDocumentStatus">
        <mat-option value="YES">Да</mat-option>
        <mat-option value="NO">Нет</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Причина / Комментарий</mat-label>
      <textarea matInput [(ngModel)]="reason" name="reason" rows="3"></textarea>
    </mat-form-field>
  </form>

  @if (errorMessage()) {
    <div class="error-message">{{ errorMessage() }}</div>
  }
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions">
  <button mat-button (click)="close()">Отмена</button>
  <button mat-raised-button color="primary"
          (click)="submit()"
          [disabled]="!isFormValid() || loading()">
    @if (loading()) {
      <mat-spinner diameter="20"></mat-spinner>
    } @else {
      Подписать и отправить
    }
  </button>
</mat-dialog-actions>
